<public-account-shell [heading]="baseKey + '.title' | transloco" [subheading]="baseKey + '.updated' | transloco">
  <article class="legal">
    <p class="legal__intro">{{ baseKey + '.intro' | transloco }}</p>

    @for (index of sectionIndexes; track index) {
      <section class="legal__section">
        <h2 class="legal__heading">{{ baseKey + '.sections.' + index + '.title' | transloco }}</h2>
        <p class="legal__text">{{ baseKey + '.sections.' + index + '.text' | transloco }}</p>
      </section>
    }

    <p class="legal__contact">
      {{ 'account.legal.contactPrefix' | transloco }}
      <a href="mailto:info@mechanicsinmotion.be">info&#64;mechanicsinmotion.be</a>
    </p>

    <p class="legal__footer">
      <a routerLink="/register" class="legal__link">{{ 'account.legal.backToRegister' | transloco }}</a>
    </p>
  </article>
</public-account-shell>
